export default __webpack_public_path__ + "static/media/error.a79ea0a4.png";